import React from 'react'

const BenefitsMapSection = () => (
  <section className="relative px-5 bg-[#3c4250]">
    <div className="absolute z-0 items-center hidden h-full sm:flex left-4 md:left-8 top-1/4 opacity-60">
      <img src="/images-optimized/Pin_grau.gif" className="max-w-[175px] sm:max-w-none z-0" alt="" />
    </div>
    <div className="container relative z-10 py-10 mx-auto sm:py-14 lg:py-16">
      <div className="flex flex-col lg:flex-row lg:items-center lg:gap-12">
        <div id="benefits-tiles" className="w-full lg:w-1/2">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="benefit-card" data-ani="benefits-tile">
              <img
                src="/images-optimized/Icon_Bewertung.gif"
                loading="lazy"
                alt="kostenfreie Onlinebewertung"
                className="benefit-illustration"
              />
              <div className="benefit-caption">kostenfreie<br />Onlinebewertung</div>
            </div>
            <div className="benefit-card" data-ani="benefits-tile">
              <img
                src="/images-optimized/Icon_Gutachter.gif"
                loading="lazy"
                alt="unabh&auml;ngige Gutachter"
                className="benefit-illustration"
              />
              <div className="benefit-caption">unabh&auml;ngige<br />Gutachter</div>
            </div>
            <div className="benefit-card" data-ani="benefits-tile">
              <img
                src="/images-optimized/Icon_Partner.gif"
                loading="lazy"
                alt="starke Partner"
                className="benefit-illustration"
              />
              <div className="benefit-caption">starke<br />Partner</div>
            </div>
            <div className="benefit-card" data-ani="benefits-tile">
              <img
                src="/images-optimized/Icon_Service.gif"
                loading="lazy"
                alt="ausgezeichneter Service"
                className="benefit-illustration"
              />
              <div className="benefit-caption">ausgezeichneter<br />Service</div>
            </div>
          </div>
        </div>
        <div className="w-full lg:w-1/2 mt-10 lg:mt-0" id="standorte">
          <div className="flex justify-center w-full sm:p-8">
            <div className="embed-container ratio6x5">
              <iframe className="lazy" scrolling="no" src="/ani/map/frame.htm" title="Standorte Karte"></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default BenefitsMapSection
